// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.Audiopage_main__eQ2HG {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 50px;
}

.Audiopage_section__DYIDU {
  text-align: center;
  position: relative;
  display: inline-block;
  margin: 0 auto;
  padding: 10px 20px;
}

/* Subtle, elegant subtitle */
.Audiopage_sectionSubtitle__WHhtr {
  display: block;
  font-weight: 600;
  font-size: 14px;
  color: #718096; /* Subtle slate gray */
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 6px;
  opacity: 0.85;
  transition: transform 0.3s ease;
}

/* The Main H1 Heading */
.Audiopage_sectionTitle__\\+f6Kx {
  color: #406343;
  font-size: 36px;
  font-weight: 800;
  margin: 0;
  position: relative;
  display: inline-block;
  padding-bottom: 12px;
  transition: color 0.3s ease;
}

/* Animated accent line underneath the title */
.Audiopage_sectionTitle__\\+f6Kx::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 50px;
  height: 3px;
  background: linear-gradient(90deg, transparent, #406343, transparent);
  border-radius: 2px;
  transition: width 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* Interaction Effects */
.Audiopage_section__DYIDU:hover .Audiopage_sectionSubtitle__WHhtr {
  transform: translateY(-2px);
}

.Audiopage_section__DYIDU:hover .Audiopage_sectionTitle__\\+f6Kx::after {
  width: 100px; /* Line expands gracefully on hover */
}

.Audiopage_main__eQ2HG p {
    color: #7f7f7f;
    font-weight: bold;
    line-height: 1.8;
    margin-bottom: 10px;
}

.Audiopage_para__UWRBe {
  margin-top: 75px;
  padding-bottom: 75px;
  font-size: 17px;
}

.Audiopage_container__7Wxxc {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto; 
    padding: 0 20px;
    text-align: center;
}

.Audiopage_bodyContent__rTHhz {
    display: flex;
    gap: 50px;
    width: 100%;
}

/* Container breakpoints with centering */
@media (min-width: 576px) {
    .Audiopage_container__7Wxxc, .Audiopage_container-sm__eJL0G {
        max-width: 540px;
        margin: 0 auto;
    }
}

@media (min-width: 768px) {
    .Audiopage_container__7Wxxc, .Audiopage_container-md__gRcn8 {
        max-width: 720px;
        margin: 0 auto;
    }
}

@media (min-width: 992px) {
    .Audiopage_container__7Wxxc, .Audiopage_container-lg__wVnUW {
        max-width: 960px;
        margin: 0 auto;
    }
}

@media (min-width: 1200px) {
    .Audiopage_container__7Wxxc, .Audiopage_container-xl__ab4mV {
        max-width: 1100px;
        margin: 0 auto;
    }
}

@media (min-width: 1400px) {
    .Audiopage_container__7Wxxc, .Audiopage_container-xxl__5ONsw {
        max-width: 1220px;
        margin: 0 auto;
    }
}

@media (min-width: 1600px) {
    .Audiopage_container__7Wxxc, .Audiopage_container-xxxl__CLRu6 {
        max-width: 1400px;
        margin: 0 auto;
    }
}

@media (min-width: 1920px) {
    .Audiopage_container__7Wxxc, .Audiopage_container-4k__tXvlE {
        max-width: 1550px;
        margin: 0 auto;
    }
}

.Audiopage_speeches__nrvAL.Audiopage_section-before-footer__Ltqx2 {
    margin-bottom: 180px !important;
}

@media (max-width: 768px) {
    .Audiopage_speeches__nrvAL.Audiopage_section-before-footer__Ltqx2 {
        margin-bottom: 220px !important;
    }
    
    .Audiopage_container__7Wxxc {
        padding: 0 15px;
    }
    
    .Audiopage_bodyContent__rTHhz {
        flex-direction: column;
        gap: 20px;
    }
}

@media (max-width: 480px) {
    .Audiopage_speeches__nrvAL.Audiopage_section-before-footer__Ltqx2 {
        margin-bottom: 280px !important;
    }
    
    .Audiopage_container__7Wxxc {
        padding: 0 10px;
    }
    
    .Audiopage_bodyContent__rTHhz {
        gap: 15px;
    }
}










/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) {
  .Audiopage_container__7Wxxc, .Audiopage_container-md__gRcn8 {
    max-width: 720px;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .Audiopage_container__7Wxxc, .Audiopage_container-lg__wVnUW {
    max-width: 960px;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .Audiopage_container__7Wxxc, .Audiopage_container-xl__ab4mV {
    max-width: 1140px;
  }
}

/* XX-Large devices (larger desktops, 1400px and up) */
@media (min-width: 1400px) {
  .Audiopage_container__7Wxxc, .Audiopage_container-xxl__5ONsw {
    max-width: 1320px;
  }
}

/* XXX-Large devices (extra large desktops, 1600px and up) */
@media (min-width: 1600px) {
  .Audiopage_container__7Wxxc, .Audiopage_container-xxxl__CLRu6 {
    max-width: 1500px;
  }
}

/* 4K and larger displays (1920px and up) */
@media (min-width: 1920px) {
  .Audiopage_container__7Wxxc, .Audiopage_container-4k__tXvlE {
    max-width: 1800px;
  }
}`, "",{"version":3,"sources":["webpack://./src/website/Audio/Audiopage.module.css"],"names":[],"mappings":";AACA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc,EAAE,sBAAsB;EACtC,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,+BAA+B;AACjC;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA,8CAA8C;AAC9C;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,qEAAqE;EACrE,kBAAkB;EAClB,2DAA2D;AAC7D;;AAEA,wBAAwB;AACxB;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY,EAAE,qCAAqC;AACrD;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,WAAW;AACf;;AAEA,yCAAyC;AACzC;IACI;QACI,gBAAgB;QAChB,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,cAAc;IAClB;AACJ;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI;QACI,+BAA+B;IACnC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;AACJ;;AAEA;IACI;QACI,+BAA+B;IACnC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;AACJ;;;;;;;;;;;AAWA,2CAA2C;AAC3C;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,wDAAwD;AACxD;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,sDAAsD;AACtD;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,4DAA4D;AAC5D;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":["\r\n.main {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-bottom: 50px;\r\n}\r\n\r\n.section {\r\n  text-align: center;\r\n  position: relative;\r\n  display: inline-block;\r\n  margin: 0 auto;\r\n  padding: 10px 20px;\r\n}\r\n\r\n/* Subtle, elegant subtitle */\r\n.sectionSubtitle {\r\n  display: block;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  color: #718096; /* Subtle slate gray */\r\n  text-transform: uppercase;\r\n  letter-spacing: 1px;\r\n  margin-bottom: 6px;\r\n  opacity: 0.85;\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n/* The Main H1 Heading */\r\n.sectionTitle {\r\n  color: #406343;\r\n  font-size: 36px;\r\n  font-weight: 800;\r\n  margin: 0;\r\n  position: relative;\r\n  display: inline-block;\r\n  padding-bottom: 12px;\r\n  transition: color 0.3s ease;\r\n}\r\n\r\n/* Animated accent line underneath the title */\r\n.sectionTitle::after {\r\n  content: '';\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 50px;\r\n  height: 3px;\r\n  background: linear-gradient(90deg, transparent, #406343, transparent);\r\n  border-radius: 2px;\r\n  transition: width 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n}\r\n\r\n/* Interaction Effects */\r\n.section:hover .sectionSubtitle {\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.section:hover .sectionTitle::after {\r\n  width: 100px; /* Line expands gracefully on hover */\r\n}\r\n\r\n.main p {\r\n    color: #7f7f7f;\r\n    font-weight: bold;\r\n    line-height: 1.8;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.para {\r\n  margin-top: 75px;\r\n  padding-bottom: 75px;\r\n  font-size: 17px;\r\n}\r\n\r\n.container {\r\n    width: 100%;\r\n    max-width: 1200px;\r\n    margin: 0 auto; \r\n    padding: 0 20px;\r\n    text-align: center;\r\n}\r\n\r\n.bodyContent {\r\n    display: flex;\r\n    gap: 50px;\r\n    width: 100%;\r\n}\r\n\r\n/* Container breakpoints with centering */\r\n@media (min-width: 576px) {\r\n    .container, .container-sm {\r\n        max-width: 540px;\r\n        margin: 0 auto;\r\n    }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n    .container, .container-md {\r\n        max-width: 720px;\r\n        margin: 0 auto;\r\n    }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n    .container, .container-lg {\r\n        max-width: 960px;\r\n        margin: 0 auto;\r\n    }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n    .container, .container-xl {\r\n        max-width: 1100px;\r\n        margin: 0 auto;\r\n    }\r\n}\r\n\r\n@media (min-width: 1400px) {\r\n    .container, .container-xxl {\r\n        max-width: 1220px;\r\n        margin: 0 auto;\r\n    }\r\n}\r\n\r\n@media (min-width: 1600px) {\r\n    .container, .container-xxxl {\r\n        max-width: 1400px;\r\n        margin: 0 auto;\r\n    }\r\n}\r\n\r\n@media (min-width: 1920px) {\r\n    .container, .container-4k {\r\n        max-width: 1550px;\r\n        margin: 0 auto;\r\n    }\r\n}\r\n\r\n.speeches.section-before-footer {\r\n    margin-bottom: 180px !important;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .speeches.section-before-footer {\r\n        margin-bottom: 220px !important;\r\n    }\r\n    \r\n    .container {\r\n        padding: 0 15px;\r\n    }\r\n    \r\n    .bodyContent {\r\n        flex-direction: column;\r\n        gap: 20px;\r\n    }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .speeches.section-before-footer {\r\n        margin-bottom: 280px !important;\r\n    }\r\n    \r\n    .container {\r\n        padding: 0 10px;\r\n    }\r\n    \r\n    .bodyContent {\r\n        gap: 15px;\r\n    }\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n/* Medium devices (tablets, 768px and up) */\r\n@media (min-width: 768px) {\r\n  .container, .container-md {\r\n    max-width: 720px;\r\n  }\r\n}\r\n\r\n/* Large devices (desktops, 992px and up) */\r\n@media (min-width: 992px) {\r\n  .container, .container-lg {\r\n    max-width: 960px;\r\n  }\r\n}\r\n\r\n/* Extra large devices (large desktops, 1200px and up) */\r\n@media (min-width: 1200px) {\r\n  .container, .container-xl {\r\n    max-width: 1140px;\r\n  }\r\n}\r\n\r\n/* XX-Large devices (larger desktops, 1400px and up) */\r\n@media (min-width: 1400px) {\r\n  .container, .container-xxl {\r\n    max-width: 1320px;\r\n  }\r\n}\r\n\r\n/* XXX-Large devices (extra large desktops, 1600px and up) */\r\n@media (min-width: 1600px) {\r\n  .container, .container-xxxl {\r\n    max-width: 1500px;\r\n  }\r\n}\r\n\r\n/* 4K and larger displays (1920px and up) */\r\n@media (min-width: 1920px) {\r\n  .container, .container-4k {\r\n    max-width: 1800px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `Audiopage_main__eQ2HG`,
	"section": `Audiopage_section__DYIDU`,
	"sectionSubtitle": `Audiopage_sectionSubtitle__WHhtr`,
	"sectionTitle": `Audiopage_sectionTitle__+f6Kx`,
	"para": `Audiopage_para__UWRBe`,
	"container": `Audiopage_container__7Wxxc`,
	"bodyContent": `Audiopage_bodyContent__rTHhz`,
	"container-sm": `Audiopage_container-sm__eJL0G`,
	"container-md": `Audiopage_container-md__gRcn8`,
	"container-lg": `Audiopage_container-lg__wVnUW`,
	"container-xl": `Audiopage_container-xl__ab4mV`,
	"container-xxl": `Audiopage_container-xxl__5ONsw`,
	"container-xxxl": `Audiopage_container-xxxl__CLRu6`,
	"container-4k": `Audiopage_container-4k__tXvlE`,
	"speeches": `Audiopage_speeches__nrvAL`,
	"section-before-footer": `Audiopage_section-before-footer__Ltqx2`
};
export default ___CSS_LOADER_EXPORT___;
